<template>
  <div class="add-pay-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="600px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="params" :rules="rules" label-width="100px">
        <el-form-item label="网址:" prop="domain">
          <div class="xiangqin" v-for="(item,i) in params.domain" :key="i">
            <div class="xiangqin_left">
              url: <el-input size="small" v-model="item.url"></el-input>
            </div>
            <div class="xiangqin_left">
              权重: <el-input size="small" v-model.number="item.weight"></el-input>
            </div>
            <div class="xiangqin_right">
              <el-button type="primary" icon="el-icon-delete" size="small" @click="deleteItem(i)"></el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="网址操作:">
          <el-button type="primary" size="small" @click="addDomain({url:'',weight:''})">新增网址</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
// import { validatorIndex } from '@/utils/validator'
export default {
  data() {
    return {
      dialogVisible: false,
      title: '',
      flag: false,
      id: '',
      params: {
        domain: [],
        isActive: true
      },
      rules: {
        domain: [
          { required: true, message: '请添加推广落地页地址', trigger: 'blur' },
          { validator: this.validatorAttr, trigger: 'blur' },
        ],
      }
    }
  },
  methods: {
    // 校验domain的数据是否正确
    validatorAttr(rule, value, callback) {
      if (value.length === 0) {
        callback(new Error("请添加网址"));
      } else {
        for (let i = 0; i < value.length; i++) {
          if (!value[i].url) {
            callback(new Error("请填写所有的url项"));
          }
          if (value[i].weight === '') {
            callback(new Error("请填写所有的权重项"));
          }
        }
        callback();
      }
    },
    // 删除某项
    deleteItem(i) {
      this.params.domain.splice(i, 1)
    },
    // 新增域名
    addDomain(obj) {
      this.params.domain.push(obj)
    },
    // 提交修改
    submitForm() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.flag = true
          if (this.title === '新增推广落地页配置') {
            this.addPromote()
          } else {
            this.editPromote()
          }
        } else {
          return false
        }
      })
    },
    // 修改推广落地页配置
    editPromote() {
      let params = Object.assign({}, this.params, { id: this.id })
      API.updatePromote(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '修改推广落地页配置成功',
            type: 'success'
          })
          this.$emit('handlerPromoteList')
        } else {
          this.$message.error('修改推广落地页配置失败')
        }
        this.flag = false
        this.handleClose()
      }).catch(() => {
        this.flag = false
        this.handleClose()
      })
    },
    // 添加推广落地页配置
    addPromote() {
      let params = Object.assign({}, this.params)
      API.addPromote(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '新增推广落地页配置成功',
            type: 'success'
          })
          this.$emit('handlerPromoteList')
        } else {
          this.$message.error('新增推广落地页配置失败')
        }
        this.flag = false
        this.handleClose()
      }).catch(() => {
        this.flag = false
        this.handleClose()
      })
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        domain: [],
        isActive: true,
      }
      this.$refs['form'].resetFields()
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.dialogVisible = true
      if (type === 'edit') {
        this.title = '编辑推广落地页配置'
        this.params.domain = [...data.domain]
        this.id = data.id
      } else {
        this.title = '新增推广落地页配置'
      }
    }
  }

}
</script>

<style lang="scss" >
.add-pay-box {
  .el-input {
    width: 150px;
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .xiangqin {
    // width: 300px;
    // padding-left: 180px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .xiangqin_left {
      margin-right: 15px;
    }
    .el-form-item {
      margin-left: 0px;
    }
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
